import {createStore} from "vuex";
import user from "./modules/user.js";
import orders from "./modules/orders.js";
import aggregators from "./modules/aggregators";
import couriers from "./modules/couriers";
import stop_list from "./modules/stop_list";
export default createStore({
    modules: {
        user,
        orders,
        aggregators,
        couriers,
        stop_list,
    }
})
